import { render, staticRenderFns } from "./offlinecourse.vue?vue&type=template&id=297c798f&scoped=true&"
import script from "./offlinecourse.vue?vue&type=script&lang=js&"
export * from "./offlinecourse.vue?vue&type=script&lang=js&"
import style0 from "./offlinecourse.vue?vue&type=style&index=0&id=297c798f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c798f",
  null
  
)

export default component.exports